export const PaymentOptions = [
  { value: "Cash", label: "Cash" },
  { value: "Credit Card", label: "Credit Card" },
  { value: "Debit Card", label: "Debit Card" },
  { value: "UPI", label: "UPI" },
  { value: "Cheque", label: "Cheque" },
  {
    value: "Advance Deposit",
    label: "Advance Deposit",
  },
  { value: "Others", label: "Others" },
];
